import type { ApplicationStatusResponse } from "@credit-acceptance/step6-bff-client";

import { descriptionsForCodes } from "./dealStatusCatalog";

// CC's known statusDescription aliases ("Contract Completed"/"Booked") —
// sourced from dealStatusCatalog, not a local literal set (mirrors
// isPreApprovalApp.ts's AP/PD usage).
const CONTRACT_COMPLETED_STATUSES = descriptionsForCodes("CC");

/**
 * Pure predicate for whether a deal's current status is Contract Completed:
 * `statusDescription` is one of CC's known aliases ("Contract Completed" or
 * "Booked"). Mirrors legacy Step6Bean.buildScreen's CC check, which hides the
 * footer Save button once a deal reaches this status.
 * @param {ApplicationStatusResponse | undefined} status - The BFF application status response.
 * @returns {boolean} True when the deal's status is Contract Completed.
 */
export function isContractCompleted(status: ApplicationStatusResponse | undefined): boolean {
  const statusDescription = status?.statusDescription?.trim();
  return !!statusDescription && CONTRACT_COMPLETED_STATUSES.has(statusDescription);
}
